var DetailTableDrgCheckController = (function () {
    function DetailTableDrgCheckController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'goe_data';
        this.requiredCountrySearch = true;
        this.goeResult = [_.get(this.topic, 'checksData.result.GOE.data.goeResult', [])]; //ToDo: rewrite that arrayish structure
        this.goeError = _.get(this.topic, 'checksData.result.GOE.error', '');
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        this.errorCheckerInput = false;
        this.cmrData = {};
        this.filterDisplay = false;
        this.bol = false;
        this.selectedCustName = [];
        this.tableName = 'Deal Registration Government Check';
        this.cmrData.cmrIssuingCountry = '';
        this.cmrData.customerCountryLanded = '';
        this.cmrData.fuzzyOption = 'Contains';
        this.cmrData.cmrOwner = 'IBM';
        this.cmrData.cmrTypeStandard = true;
        this.cmrData.accTypeSoldTo = true;
        this.cmrData.customerName = 'CustNameOnly';
        this.cmrData.rows = '500';
        this.cmrData.cmrNum = '';
        this.cmrData.fuzzySearch = '';
        this.visible = false;
        this.expand = false;
        this.dataSources = ['CMR'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.processing = false;
        this.fuzzyOptions = ['Contains', 'Begins with', 'Fuzzy'];
        this.resultRows = ['50', '100', '500', '1000', '5000'];
        this.cmrOwnerOptions = ['ALL', 'IBM', 'Lenovo', 'Truro', 'Fonseca'];
        this.custNameOptions = [
            { name: 'Customer Name Only', value: 'CustNameOnly' },
            { name: 'Business Name Only', value: 'BusNameOnly' },
            { name: 'Customer & Business Name', value: 'CustBusName' }
        ];
    }
    DetailTableDrgCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableDrgCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs', '_'];
    return DetailTableDrgCheckController;
}());
var DetailTableDrgCheckComponent = (function () {
    function DetailTableDrgCheckComponent() {
        this.templateUrl = 'detail-table-drgcheck.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableDrgCheckController;
    }
    return DetailTableDrgCheckComponent;
}());
angular
    .module('application')
    .component('detailTableDrgCheck', new DetailTableDrgCheckComponent());

//# sourceMappingURL=detail.table.drgcheck.component.js.map
